import React from "react";
import styled from "styled-components";
import WorkoutStep from "./WorkoutStep";
import { WorkoutPayload } from "./types";

const WorkoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
`;

const Description = styled.p`
  margin: 0;
  color: #475569;
`;

const Meta = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

interface WorkoutProps {
  workout: WorkoutPayload;
}

const Workout: React.FC<WorkoutProps> = ({ workout }) => {
  return (
    <WorkoutContainer>
      <Header>
        <Meta>{workout.sport}</Meta>
        <Title>{workout.workoutName}</Title>
        {workout.description && <Description>{workout.description}</Description>}
      </Header>

      <Steps>
        {workout.steps.map((step) => (
          <WorkoutStep key={step.stepOrder} step={step} />
        ))}
      </Steps>
    </WorkoutContainer>
  );
};

export default Workout;
